import { useState, useRef } from 'preact/hooks';
import { useAuth } from './context';

export function LoginPage() {
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async () => {
    const value = inputRef.current?.value?.trim();
    if (!value) return;

    setError('');
    setLoading(true);
    try {
      await login(value);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Authentication failed');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') handleSubmit();
  };

  return (
    <div class="login-view">
      <div class="login-wrap">
        <div class="login-brand">
          <div class="dot" />
          <span>Sift</span>
        </div>
        <p class="login-sub">Backend management console</p>
        <div class="login-card">
          <label class="login-label">Admin Secret</label>
          <input
            ref={inputRef}
            type="password"
            placeholder="Enter admin secret"
            autocomplete="off"
            onKeyDown={handleKeyDown}
          />
          <button class="btn-primary" onClick={handleSubmit} disabled={loading}>
            {loading ? (
              <>
                <span class="spinner" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
                Authenticating...
              </>
            ) : 'Sign In'}
          </button>
          {error && <div class="msg msg-error" style={{ marginTop: '16px' }}>{error}</div>}
        </div>
      </div>
    </div>
  );
}
